import { colors } from '../../colors';
var header = {
  primaryColor: colors.graphite,
  hoverColor: colors.deepRed,
  borderColor: colors.overcast,
  bgColor: colors.white,
  barColor: colors.graphite,
  navContactLinkHoverTextDecoration: "underline",
  navUtilityLinkColor: colors.nevada,
  navUtilityLinkHoverColor: colors.nevada,
  navUtilityLinkTextDecoration: "none",
  navUtilityLinkHoverTextDecoration: "underline",
  topNavLineHeight: '15px'
};
export default header;